import { gql } from "@apollo/client";
import { HealthQuestionnaireOnOfferFragmentDoc } from '../fragments/healthQuestionnaireOnOffer.fragment';

export const getCheckoutDataAdditional = gql`
  ${HealthQuestionnaireOnOfferFragmentDoc}
query GetCheckoutDataAdditional($id: String!) {
  getOfferPaymentOptions(id: $id) {
    paymentOptions {
      paymentOption
      paymentTypes {
        paymentType
        paymentTypeLabel
        installments {
          installment
          amount
          paymentTypeDiscount
        }
      }
    }
  }
  getOffer(id: $id) {
    _id
    soId
    status
    productTypeSpecific {
      shoppingCartId
      ...HealthQuestionnaireOnOffer
      additional {
        code
        coverages { code label description }
        priceChangeModifier { amount type description }
        voucherPriceModifier { amount }
        voucherPriceChangeModifier { amount type description code }
        gratis { additionalSecondOpinion }
      }
      calculatedPrices {
        additional { baseProductPrice total { generalTransfer creditCard } }
        total { generalTransfer generalTransferWithInstallments creditCard creditCardWithInstallments }
      }
      insuredPerson {
        firstName
        lastName
        birthDate
        partnerContactEmail
        importantNote
        gender
        street
        streetKompareId
        houseNumber
        city
        zipCode
        personType
        asEntity
        streetAndHouseNumber
        cityKompareId
        oib
        karenca
        insuranceNumber
      }
      delivery {
        firstName
        lastName
        gender
        street
        streetKompareId
        isRegularDelivery
        houseNumber
        city
        birthDate
        zipCode
        personType
        asEntity
        streetAndHouseNumber
        cityKompareId
      }
      contractor {
        firstName
        lastName
        gender
        street
        streetKompareId
        houseNumber
        city
        birthDate
        zipCode
        personType
        asEntity
        streetAndHouseNumber
        cityKompareId
        partnerContactEmail
        oib
        isSamePerson
      }
    }
    product {
      name
      code
      brand { code name logoUrl }
      annotations
      fixedCoverages { code label description }
    }
  }
}
`;